import { useEffect } from 'react';

import * as Types from '../types';

export const useXpointGeofencingHandler = ({
    triggerGeolocation,
    receivePacket,
    onConnect,
    onError
}: {
    onError: CallableFunction;
    onConnect: CallableFunction;
    receivePacket: Types.ReceivePacketCallback;
    triggerGeolocation: Types.TriggerGeolocationCallback;
}) => {
    useEffect(() => {
        window.geofencingHandler = {
            trigger: () => triggerGeolocation(),
            init: () => onConnect(),
            geopacket: (transactionID, geoPacket) => receivePacket(geoPacket, transactionID),
            error: (transactionID, errorCode, message) => onError(errorCode, message)
        };
    }, [
        triggerGeolocation,
        receivePacket,
        onConnect,
        onError
    ]);
};
